import SettingsAlertsPage from '@/components/pages/Settings/account/SettingsAlertsPage/SettingsAlertsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$workspaceName/$environment/account-settings/alerts')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SettingsAlertsPage />
}
